import { array } from 'yup';

import type { AnyObject, ArraySchema } from 'yup';

const imageFormats = ['.jpg', '.jpeg', '.png', '.bmp', '.svg']; // Graphic
const videoFormats = ['.mp4', '.avi', '.mkv', '.mov', '.wmv', '.flv', '.mpeg']; // Video
const audioFormats = ['.mp3', '.wav', '.flac', '.aac', '.ogg', '.m4a']; // Audio
const documentFormats = ['.pdf']; // Other files
const textFormats = ['.txt', '.rtf', '.csv']; // Text files
const emailFormats = ['.eml', '.msg', '.mbox']; // Mail export
const officeFormats = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.odt', '.ods', '.odp']; // Office packages

const allowedFormats = [
  ...imageFormats,
  ...videoFormats,
  ...audioFormats,
  ...documentFormats,
  ...textFormats,
  ...emailFormats,
  ...officeFormats,
];

export const fileValidation = (
  filesSizeMessage: string,
  filesTotalSizeMessage: string,
  filesExtensionMessage: string,
): ArraySchema<unknown[] | undefined, AnyObject, unknown, ''> =>
  array()
    .max(15, 'invalid.filesLimit')
    .test(
      'file-size',
      filesSizeMessage,
      (files: File[] | undefined) =>
        files ? files.every((file) => file.size <= 15 * 1024 * 1024) : true, // maximum size of 15 MB per file
    )
    .test('total-size', filesTotalSizeMessage, (files: File[] | undefined) => {
      if (!files) {
        return true;
      }

      const totalSize = files.reduce((acc, file) => acc + file.size, 0);

      return totalSize <= 100 * 1024 * 1024; // maximum size 100 MB in total
    })
    .test('file-type', filesExtensionMessage, (files: File[] | undefined) => {
      if (!files) {
        return true;
      }
      return files.every((file) => {
        const extension = file.name.includes('.') ? file.name.split('.').pop()?.toLowerCase() : '';
        return !!extension && allowedFormats.includes(`.${extension}`);
      });
    });
